const tileDropdownToggle = (tileId, toggle) => {
  if (toggle === 'show') {
    document
      .getElementById(`single-tile-${tileId}`)
      .children[0].classList.add('active_menu');
  } else {
    document
      .getElementById(`single-tile-${tileId}`)
      .children[0].classList.remove('active_menu');
  }
};

const menuButtonBase = (type, faIcon, handleAction, tile) => ({
  attrs: {
    className: `${type === 'copy' ? 'duplicate' : type}_title`,
    style: { width: '100%' },
  },
  faIcon,
  text: type
    .split('-')
    .map(word => word.replace(/^\w/g, char => char.toUpperCase()))
    .join(' '),
  clickEvent: () => {
    handleAction(tile);
  },
});

const renderMenuButtons = ({ moveTileToProof, copyTile, deleteTile, tile }) => {
  const result = [
    menuButtonBase('move-to-proof', 'fa-solid fa-right-long', moveTileToProof, tile),
    menuButtonBase('copy', 'fa-regular fa-copy', copyTile, tile),
    menuButtonBase('delete', 'fa-regular fa-trash-can', deleteTile, tile),
  ];

  return result;
};

export { renderMenuButtons, tileDropdownToggle };
